import { useClickOutside, usePermission } from 'hooks';
import { MoreHorizontal } from 'lucide-react';
import React, { useRef, useState } from 'react'
import { projectActions } from 'utils';

export default function Actions({ onChange }) {
    const { can, isAdmin } = usePermission()
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [isShow, setIsShow] = useState(false);

    useClickOutside(dropdownRef, () => setIsShow(false));
    const handleCalback = (act) => {
        if (!can(act, "project")) return false;
        onChange(act);
        setIsShow(false);
    }
    return (
        <div className='relative'>
            {isAdmin && <button
                onClick={() => setIsShow(true)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors bg-gray-100 text-gray-700 hover:bg-gray-200`}
            >
                <MoreHorizontal className="text-gray-500" />
            </button>}
            <div ref={dropdownRef} className={`${!isShow ? 'hidden' : ''} max-w-[120px] absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50`}>
                <ul className="py-1">
                    {projectActions.map(act => {
                        if (!can(act.action, "project")) return <></>;
                        return (
                            <li key={act.action} onClick={() => handleCalback(act.action)} className="flex items-center px-4 py-2 hover:bg-gray-50 cursor-pointer text-sm text-gray-700">
                                {act.icon} {act.name}
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    )
}
